/**
 * Where the browser goes to sign in.
 *
 * Every entry point here is a *full-page navigation to the Suite's own API*.
 * The browser never sees a provider URL, a client id or a token: the server
 * builds the authorization request, keeps the PKCE verifier and the flow state
 * server-side, and sets a cookie the app cannot read (ADR-0003/0004, blueprint
 * 03 §3.5). That is why these are plain URLs rather than a router navigation —
 * the sign-in flow leaves the single-page app on purpose.
 */

const AUTH_BASE = '/api/v1/auth'

/**
 * A `return_to` the server will accept: a same-site path, never an absolute
 * URL and never a protocol-relative one. The API ignores anything else; this
 * keeps the app from sending it in the first place.
 */
export function sameSitePath(pathname: string, search = ''): string {
  const path = pathname.startsWith('/') && !pathname.startsWith('//') ? pathname : '/'
  return `${path}${search}`
}

export function signInUrl(returnTo: string): string {
  return `${AUTH_BASE}/login?${new URLSearchParams({ return_to: returnTo }).toString()}`
}

/**
 * The magic-link entry. `method=link` is the contract with the magic-link
 * story; until that lands the API ignores the parameter and starts an ordinary
 * sign-in, which is why nothing on this page depends on it.
 */
export function signInLinkUrl(email: string, returnTo: string): string {
  return `${AUTH_BASE}/login?${new URLSearchParams({ method: 'link', email, return_to: returnTo }).toString()}`
}

/** Leaves the app. Kept here so a test can watch for it in one place. */
export function leaveTo(url: string): void {
  window.location.assign(url)
}
